import { render, staticRenderFns } from "./DownChart.vue?vue&type=template&id=4ba4d214"
import script from "./DownChart.vue?vue&type=script&lang=js"
export * from "./DownChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports